// extracted by mini-css-extract-plugin
export default {"languageSwitchKey":"LanguageSwitchButton_languageSwitchKey__krD4E"};